import type {DialogAttrs} from '@jetbrains/ring-ui/components/dialog/dialog'
import Dialog from '@jetbrains/ring-ui/components/dialog/dialog'

import {pipelinesAppId} from '../../../PipelinesPages.consts'

function PipelineDialog(props: DialogAttrs) {
  const portalTarget = document.getElementById(pipelinesAppId)

  return <Dialog portalTarget={portalTarget} {...props} />
}

export default PipelineDialog
